module.exports = __webpack_public_path__ + "static/media/drop-down-disabled.007b04f5.svg";